export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13912.8df525fe.jpg";